import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { usePageTitle } from "../lib/use-page-title";
import { OrderDetailView } from "../components/sale/OrderDetailView";

export function OrderDetailPage() {
  const { t } = useTranslation();
  const params = useParams();
  const orderId = params.id ?? "";
  usePageTitle("orderDetail");

  if (!orderId) {
    return <p className="py-12 text-sm text-muted">{t("orderDetail.notFoundBody")}</p>;
  }

  return <OrderDetailView orderId={orderId} mode="page" />;
}
